module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table a-table--modal",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [(_vm.data.table.thead[0].length) ? _c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.data.table.thead[1].length
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                        " + _vm._s(_vm.data.table.thead[0]) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.data.table.thead[1]), function(column) {
    return _c('th', [_vm._v("\n                    " + _vm._s(column) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', {
        class: {
          'a-table--highlight': column.highlight
        }
      }, [_vm._v("\n                    " + _vm._s(column.value) + "\n                ")])
    }), 0)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bf4e338!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/TableData.vue
// module id = 1680
// module chunks = 0